import FirebaseContext from './context';
import firebaseApp from './firebase';

export default firebaseApp;

export { FirebaseContext };
